import { UnstyledLink } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';
import styles from './WidgetHeader.module.scss';

export interface HeaderTitleProps {
  href?: string;
  title?: string;
  titleClassName?: string;
}

const HeaderTitle: React.FC<HeaderTitleProps> = ({
  href,
  title,
  titleClassName,
}) => {
  const heading = <h1 className={cn(styles.title, titleClassName)}>{title}</h1>;

  return href ? (
    <UnstyledLink
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      className={cn(styles.link)}
    >
      {heading}
    </UnstyledLink>
  ) : (
    heading
  );
};
export default HeaderTitle;
